// extracted by mini-css-extract-plugin
module.exports = {"row":"SpotlightCardRow_row__2lOi5","hideFirst":"SpotlightCardRow_hideFirst__19qRo","hideSecond":"SpotlightCardRow_hideSecond__2ik2M"};